import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';
import ProductHero from './components/ProductHero';
import ProductGrid from './components/ProductGrid';
import ProductFeatures from './components/ProductFeatures';
import ProductCTA from './components/ProductCTA';
import BlogPromo from './components/BlogPromo';

export default function ProductsPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    // 设置页面标题和meta标签
    document.title = 'PDF处理产品 - Adobe PDF Library SDK、转换器、表单扩展 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '星允信息提供专业的PDF SDK、转换器和智能处理工具，包括Adobe PDF Library SDK、PDF转换器、PDF表单扩展SDK、pdfRest API Toolkit Container，满足企业文档数字化需求。支持跨平台集成，提供技术支持。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adobe PDF Library SDK,PDF转换器,PDF表单扩展,pdfRest API,PDF开发工具,文档处理SDK,企业PDF解决方案');
    }

    // 更新canonical链接
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/products`);

    // 添加产品结构化数据
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "PDF处理产品 - 星允信息",
      "description": "专业的PDF SDK、转换器和智能处理工具，满足企业文档数字化需求",
      "url": `${siteUrl}/products`,
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "首页",
          "item": "https://documogul.com/"
        }, {
          "@type": "ListItem",
          "position": 2,
          "name": "产品",
          "item": "https://documogul.com/products"
        }]
      },
      "mainEntity": {
        "@type": "ItemList",
        "name": "PDF处理产品目录",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "item": {
              "@type": "SoftwareApplication",
              "name": "Adobe PDF Library SDK",
              "description": "专业的PDF处理开发工具包，支持C++、.NET、Java等多种开发语言，可跨平台集成到Windows、macOS、Linux系统",
              "applicationCategory": "DeveloperApplication",
              "operatingSystem": "Windows, macOS, Linux",
              "offers": {
                "@type": "Offer",
                "availability": "https://schema.org/InStock",
                "priceCurrency": "CNY",
                "price": "按需定制"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.9",
                "reviewCount": "87"
              }
            }
          },
          {
            "@type": "ListItem",
            "position": 2,
            "item": {
              "@type": "SoftwareApplication",
              "name": "Adobe PDF转换器",
              "description": "高性能文档格式转换工具，支持PDF与Word、Excel、图片等多种格式互转，保持原始格式和布局",
              "applicationCategory": "BusinessApplication",
              "offers": {
                "@type": "Offer",
                "availability": "https://schema.org/InStock",
                "priceCurrency": "CNY",
                "price": "按需定制"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "reviewCount": "65"
              }
            }
          },
          {
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@type": "SoftwareApplication",
              "name": "PDF表单扩展SDK",
              "description": "智能表单处理工具，支持表单识别、数据提取、自动填充等功能，提升表单处理效率",
              "applicationCategory": "BusinessApplication",
              "offers": {
                "@type": "Offer",
                "availability": "https://schema.org/InStock",
                "priceCurrency": "CNY",
                "price": "按需定制"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.7",
                "reviewCount": "52"
              }
            }
          },
          {
            "@type": "ListItem",
            "position": 4,
            "item": {
              "@type": "SoftwareApplication",
              "name": "pdfRest API Toolkit Container",
              "description": "容器化的PDF REST API工具包，提供灵活的PDF处理接口，支持云端部署和本地部署",
              "applicationCategory": "DeveloperApplication",
              "offers": {
                "@type": "Offer",
                "availability": "https://schema.org/InStock",
                "priceCurrency": "CNY",
                "price": "按需定制"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "reviewCount": "43"
              }
            }
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ProductHero />
        <ProductGrid />
        <ProductFeatures />
        <BlogPromo />
        <ProductCTA />
      </main>
      <Footer />
    </div>
  );
}
